var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('iframe',{attrs:{"src":`https://open.spotify.com/embed/${_vm.id}`,"width":"100%","height":_vm.spotifyTypeHeight[_vm.spotifyType] || 380,"frameborder":"0","allowtransparency":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }